<script lang="ts">
	import {SvelteToast, } from '@zerodevx/svelte-toast';
	import "smelte/src/tailwind.css";
	import Router from "svelte-spa-router";
	import Home from "./routes/Home.svelte";
	import About from "./routes/About.svelte";
	import Logmypoop from "./routes/Logmypoop.svelte";
	import LogmypoopPrivacy from "./routes/Logmypoopprivacy.svelte";
	import Notfound from "./routes/Notfound.svelte";
    import Pocketbirbal from './routes/Pocketbirbal.svelte';
	import TextArcher from './routes/TextArcher.svelte';

	let routes = {
		"/": Home,
		"/logmypoop": Logmypoop,
		"/logmypoop/privacy": LogmypoopPrivacy,
		"/about": About,
		"/pocketbirbal": Pocketbirbal,
		"/textarcher": TextArcher,
		"*": Notfound, 
	};
</script>
<main />
<SvelteToast options={{ duration: 4000, intro: { y: 20 } }} />
<Router {routes} />

